import React, {useEffect, useState} from 'react'

function ConteneurRejet({conteneurFalse, kiloFalse}) {
    const [nbLocked, setNbLocked] = useState(0)
    const countLockedTrue = (items)=>{
        if (!Array.isArray(items)) {
            return 0; // Retourne 0 si items n'est pas un tableau
        }
    
        return items.reduce((count, item) => (item.locked === true ? count + 1 : count), 0);
    }
    useEffect(() => {
      const nbKilo = countLockedTrue(kiloFalse)
      const nbConteneur = countLockedTrue(conteneurFalse)
      const total = nbKilo + nbConteneur
      setNbLocked(total)
    }, [conteneurFalse, kiloFalse])
    
  return (
    <div className="col-md-6 col-xl-3 mb-4">
        <div className="card shadow border-start-warning py-2">
            <div className="card-body">
                <div className="row align-items-center no-gutters">
                    <div className="col me-2">
                        <div className="text-uppercase text-warning fw-bold text-xs mb-1">
                            <span>Annonces bloquées</span>
                        </div>
                        <div className="text-dark fw-bold h5 mb-0">
                            <span>{nbLocked}</span>
                        </div>
                    </div>
                    <div className="col-auto">
                        <i className="fas fa-times-circle fa-2x text-gray-300"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ConteneurRejet